import React from "react";
import {
  Paper,
  Stack,
  Button,
  Tooltip,
  IconButton,
  Typography,
} from "@mui/material";
import { useTranslation } from "gatsby-plugin-react-i18next";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";

import getServiceDetailService from "../services/getServiceDetail.service";

export default function ServiceCard({ type, onAddServiceClick = () => { } }) {
  const { t } = useTranslation();
  const service = getServiceDetailService({ type });

  if (!service) return;

  return (
    <Paper
      sx={{
        padding: "24px 12px",
        minWidth: 175,
        maxHeight: 260,
        aspectRatio: "175/260",
        border: "3px solid transparent",
        "&:hover": {
          transition: "border 300ms ease",
          border: "3px solid rgba(239, 96, 163, 1)",
        },
      }}
    >
      <Stack
        gap="12px"
        height="100%"
        direction="column"
        justifyContent="space-between"
      >
        <img
          src={`/images/${service.icon}`}
          alt={`${service.key}-logo`}
          width={32}
          height={32}
        />
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body2" color="primary" fontWeight={700}>
            {t(service.i18n_name)}
          </Typography>
          <Tooltip title={t(service.i18n_tooltip)}>
            <IconButton size="small" sx={{ padding: 0 }}>
              <InfoRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
        <Typography
          color="secondary.light"
          variant="body2"
          minHeight={80}
          fontWeight={500}
          lineHeight="16px"
        >
          {t(service.i18n_description)}
        </Typography>
        <Button
          size="small"
          color="primary"
          variant="contained"
          onClick={onAddServiceClick}
        >
          {t("add")}
        </Button>
      </Stack>
    </Paper>
  );
}
